<template>
  <div class="row">
    <div class="col-3 align-self-end pb-0" v-for="p in profiles" :key="p._id">
      <div
        v-b-tooltip.hover
        :title="p.name"
        class="rounded-xl  px-5 py-3"
        :class="{
          'no-active': checkPoints(p._id) == 0
        }"
        :style="'background-color:' + bgColor(p.color) + ';'"
      >
        <span class="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
          <i
            class="fas font-size-h2"
            :style="'color:' + p.color"
            :class="p.image"
          ></i>
        </span>
        <a
          href="#"
          class=" font-weight-bold font-size-h5 mt-2"
          :style="'color:' + p.color"
        >
          {{ checkPoints(p._id) }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProfilesTeam",

  computed: {
    profiles() {
      return this.$store.getters.getProfiles;
    },
    team() {
      return this.$store.getters.getMyTeam|| this.$store.getters.getTeams[0];
    }
  },
  methods: {
    bgColor(i) {
      let color = i.split("1)");

      return color[0] + "0.3)";
    },
    checkPoints(profile) {
      let punts = 0;
      this.team.users.forEach(user => {
        let p = user.points.profiles.find(p => p.profile == profile);
        punts += p ? p.points : 0;
      });

      return punts;
    }
  }
};
</script>
